(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn();

    } else {
        RivalIQ.module('metrics.new.enums', function (enums) {
            enums.DataSourceFilterGroupIds = exportFn();
        });

    }

    function exportFn() {
        return {
            company: 'company',
            source: 'source',
            timePeriod: 'timePeriod',
            timezone: 'timezone',
            publicPost: 'publicPost',
            ordering: 'ordering',
            listening: 'listening'
        };
    }
})();
